<template>
  <path
    d="M11.19 1.36024L4.19 4.47024C3.47 4.79024 3 5.51024 3 6.30024V11.0002C3 16.5502 6.84 21.7402 12 23.0002C17.16 21.7402 21 16.5502 21 11.0002V6.30024C21 5.51024 20.53 4.79024 19.81 4.47024L12.81 1.36024C12.3 1.13024 11.7 1.13024 11.19 1.36024ZM12 11.9902H19C18.47 16.1102 15.72 19.7802 12 20.9302V12.0002H5V6.30024L12 3.19024V11.9902Z"
  />
</template>
